'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

require('react');
require('../../index-0e40e0c2.js');
var components_Icon_Icon = require('../../Icon-1de1fb46.js');
require('../../extends-f8003900.js');
require('../../defineProperty-3cad0327.js');
require('../../objectWithoutProperties-aa43106a.js');
require('../../xstyled-styled-components.es-02f83f64.js');
require('styled-components');
require('../../styles/themeUtils.js');
require('../../utils/isType/isType.js');
require('../../utils/env/isBrowserEnv/isBrowserEnv.js');
require('../../utils/env/isTestEnv/isTestEnv.js');
require('../../theme-41bc4eaa.js');
require('../../breakpoints-7bb24b2d.js');
require('../../unsupportedIterableToArray-a6f9513d.js');
require('../../utils/logger/logDeprecatedFeature/logDeprecatedFeature.js');
require('../../utils/env/isProdEnv/isProdEnv.js');
require('../../colorBuilder-0e3465cf.js');
require('../../polished.esm-0312677e.js');



exports.default = components_Icon_Icon.Icon;
//# sourceMappingURL=Icon.js.map
